<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-佣金设置
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <el-form-item label="一级佣金比例 ">
        <el-input v-model="form.first_money" type="number" class="max-w460"></el-input>
        <div class="tips">佣金比例范围 0% - 100%</div>
      </el-form-item>
      <el-form-item label="二级佣金比例">
        <el-input v-model="form.second_money" type="number" class="max-w460"></el-input>
        <div class="tips">佣金比例范围 0% - 100%</div>
      </el-form-item>
      <el-form-item label="三级佣金比例111  ">
        <el-input v-model="form.third_money" type="number" class="max-w460"></el-input>
        <div class="tips">佣金比例范围 0% - 100%</div>
      </el-form-item>

      <el-form-item label="购买指定商品恢复分佣">
        <div>
          <el-radio v-model="form.money_buy_product" label="0">关闭</el-radio>
          <el-radio v-model="form.money_buy_product" label="1">开启</el-radio>
          <div class="tips">开启后分销商在指定时间内要持续产生分佣，否则需要自购商品获得分佣资格</div>
          <div v-if="form.money_buy_product == 1">
            <el-input placeholder="请输入天数" v-model="form.money_day" :precision="1" :step="1" :min="1" style="width: 500px;">
              <template slot="prepend">在</template>
              <template slot="append">天后没有产生直推佣金，则需要自购商品获得分佣资格</template>
            </el-input>
          </div>
          <div v-if="form.money_buy_product == 1" style="margin-top: 10px;">
            <el-row>
              <el-button type="primary" @click="openProduct">选择商品</el-button>
              <div v-if="form.money_product_image && form.money_product_image.length > 0" class="d-s-c f-w">
                <div v-for="(item, index) in form.money_product_image" :key="index" class="img pr">
                  <a href="javascript:void(0)" class="delete-btn" @click="deleteFunc(index)"><i class="el-icon-error"></i></a>
                  <img :src="item.image" width="100" height="100" />
                  <p class="text-ellipsis">{{ item.product_name }}</p>
                </div>
              </div>
            </el-row>
          </div>
        </div>
      </el-form-item>

      <!--产品列表弹出层组件-->
      <Product :isproduct="isproduct" @closeDialog="closeDialogFunc($event)">产品列表弹出层</Product>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import PlusApi from '@/api/plus.js';
  import Product from '@/components/product/Product';
  export default {
    components: {
      /*产品列表组件*/
      Product: Product
    },
    data() {
      return {
        /*form表单数据*/
        form: {},
        /*商品列表*/
        productList: [],
        /*加载完成*/
        loading: false,
        isproduct: false,
      };
    },
    props: {
      settingData: Object
    },
    created() {

      this.form=this.settingData.data.commission.values;

    },

    methods: {

      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        PlusApi.commission(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*删除商品*/
      deleteFunc(i) {
        this.form.money_product_ids.splice(i, 1);
        this.form.money_product_image.splice(i, 1);
      },

      /*产品列表弹出层*/
      openProduct() {
        this.isproduct = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e) {
        this.isproduct = e.openDialog;
        if (e.type == 'success') {
          console.log(e.params)
          if(!this.form.money_product_ids){
            this.form.money_product_ids = [];
            this.form.money_product_image = [];
          }
          if (this.form.money_product_ids.indexOf(e.params.product_id) == -1) {
            this.form.money_product_ids.push(e.params.product_id);
            this.form.money_product_image.push({ product_id: e.params.product_id, image: e.params.product_image,product_name: e.params.product_name });
          } else {
            this.$message({
              message: '已选择该商品',
              type: 'warning'
            });
          }
        }
      }

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
  .img {
    width: 100px;
    margin-top: 10px;
    height: 130px;
    margin-right: 10px;
  }

  .img img {
    border: 1px solid #eeeeee;
  }

  .delete-btn {
    position: absolute;
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    right: -8px;
    top: -8px;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Commission.vue